import React, { useCallback, useEffect } from "react";
import ReactDOM from "react-dom";
import PropTypes from "prop-types";
import {
  ModalBackground,
  ModalWindow,
  ModalHeader,
  ModalTitle,
  ModalBody,
  ModalActions,
  CancelButton,
  ContinueButton,
  ModalCloseIcon,
  CloseIcon,
} from "./styles.js";

const CustomModal = ({
  title,
  children,
  onClose,
  primaryBtn,
  secondaryBtn,
}) => {
  const escFunction = useCallback((event) => {
    if (event.keyCode === 27) {
      onClose();
    }
  }, []);

  useEffect(() => {
    document.addEventListener("keydown", escFunction, false);

    return () => {
      document.removeEventListener("keydown", escFunction, false);
    };
  }, []);

  const MODAL_CONTENT = (
    <>
      <ModalBackground onClick={onClose} />
      <ModalWindow>
        <ModalHeader>
          <ModalTitle>{title}</ModalTitle>
          <ModalCloseIcon onClick={onClose}>
            <CloseIcon>+</CloseIcon>
          </ModalCloseIcon>
        </ModalHeader>
        <ModalBody>{children}</ModalBody>
        <ModalActions>
          <CancelButton
            type="secondary"
            label={secondaryBtn.label}
            clickHandler={secondaryBtn.clickHandler}
          ></CancelButton>
          <ContinueButton
            type="primary"
            label={primaryBtn.label}
            clickHandler={primaryBtn.clickHandler}
          ></ContinueButton>
        </ModalActions>
      </ModalWindow>
    </>
  );

  return ReactDOM.createPortal(MODAL_CONTENT, document.body);
};

CustomModal.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.any.isRequired,
  onClose: PropTypes.func,
  primaryBtn: PropTypes.shape({
    label: PropTypes.string.isRequired,
    clickHandler: PropTypes.func.isRequired,
  }),
  secondaryBtn: PropTypes.shape({
    label: PropTypes.string.isRequired,
    clickHandler: PropTypes.func.isRequired,
  }),
};
CustomModal.defaultProps = {
  title: "This is a Modal",
  children: "This is my modal content.",
};

export default CustomModal;
